const salidasDelDia = {
    ObtenerCedulasDeSalida: 'SINOJ/ConsultaSalidasDelDia/ObtenerCedulasDeSalida'
}

const consultaDireccion = {
    ObtenerCedulasConsultaDeDireccion: 'SINOJ/ConsultaDireccion/ObtenerCedulasDireccion',
    RegresarCedulaAJuzgado: 'SINOJ/ConsultaDireccion/RegresarCedulaAJuzgado',
    ObtenerHistorialAcuerdo: 'SINOJ/ConsultaDireccion/ObtenerHistorialAcuerdo',
    ObtenerDatosDeNotificador: 'SINOJ/ConsultaDireccion/ObtenerDatosDeNotificador',
    EnviarCedulasAJuzgado: 'SINOJ/ConsultaDireccion/EnviarCedulasAJuzgado',
    EliminarResultadosDeCedulas: 'SINOJ/ConsultaDireccion/EliminarResultadosDeCedulas',
    CambiarJurisdiccion: 'SINOJ/ConsultaDireccion/CambiarJurisdiccion',
    CambiarFechasDeResultado: 'SINOJ/ConsultaDireccion/CambiarFechasDeResultado',
    CancelarCedulasDireccion: 'SINOJ/ConsultaDireccion/CancelarCedulas',
    CargarInformacionDeCedula: 'SINOJ/ConsultaDireccion/CargarInformacionDeCedula',
    ObtenerReportesExportarBusquedaPDF: 'SINOJ/ConsultaDireccion/ObtenerReportesExportarBusquedaPDF',
    ObtenerReportesExportarBusquedaExcel: 'SINOJ/ConsultaDireccion/ObtenerReportesExportarBusquedaExcel'
}

const consultaSistemaViejo = {
    ObtenerCedulas: 'SINOJ/ConsultaNotificadoresViejo/ConsultaNotificaciones'
}

const consultaJuzgado = {
    ObtenerCedulasConsultaDeJuzgado: 'SINOJ/ConsultaJuzgado/ObtenerCedulasConsultaDeJuzgado',
    RegresarCedulaADireccion: 'SINOJ/ConsultaJuzgado/RegresarCedulaADireccion'
}

const consultaPublica = {
    ObtenerCedulasConsultaPublica: 'SINOJ/ConsultaPublica/ObtenerCedulasConsultaPublica',
    GuardarObservacionesDeAbogado: 'SINOJ/ConsultaPublica/GuardarObservacionesDeAbogado',
    ConsultaPublicaGeneral: 'SINOJ/ConsultaPublica/CedulasConsultaPublicaUnificada'
}

const consultas = {
    salidasDelDia: salidasDelDia,
    consultaDireccion: consultaDireccion,
    consultaJuzgado: consultaJuzgado,
    consultaPublica: consultaPublica,
    consultaSistemaViejo: consultaSistemaViejo
}

export default consultas;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/Consultas/Consultas.js
// module id = null
// module chunks = 